<template>

  <div style="width: max-content; height: 100%; margin: 0;padding: 0;position: relative">
    <input
        :readonly="editable"
        class="invoice_input"
        :class="{editing:!editable}"
        type="number"
        :placeholder="placeholder ? placeholder : ''"
        v-on:click="setEditable"
        v-click-outside="saveData"
        @keypress.enter="saveData"
        v-model="value"
        :disabled="isDisabled === true"
    >
    <div v-if="loading" style="position: absolute; top: 0;left: 0;width: 100%; height: 100%; background: #FFFFFF66">
      <sync-loader
          class="loaderDots"
          :size="6"
          :loading="loading"
      />
    </div>
  </div>

</template>

<script>
import {SyncLoader} from '@saeris/vue-spinners'
import vClickOutside from 'v-click-outside';

export default {
  name: "invoice_input",
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    SyncLoader
  },
  props: ['placeholder', 'personKey', 'id', 'item', 'selectedMonth', 'contractorData', 'dataProperty', 'disabled'],
  data() {
    return {
      isDisabled: this.disabled,
      editable: true,
      loading: false,
      value: null,
      itemName: '',
      keyName: '',
      invoice: {
        id: this.contractorData.invoice.id,
        clientCompanyName: this.contractorData.companyName, 
        clientFirstName: this.contractorData.firstName, 
        clientLastName: this.contractorData.lastName, 
        clientStreet: this.contractorData.street, 
        clientCity: this.contractorData.city,
        clientPostalCode: this.contractorData.postalCode,
        clientCountry: this.contractorData.country, 
        clientCompanyNumber: this.contractorData.businessID, 
        clientInternalTaxId: this.contractorData.taxID, 
        clientTaxId: this.contractorData.VATRegistrationNumber,
        hours: this.hours, 
        rate: this.contractorData.rate,
        active: this.contractorData.activeIncome,
        pasive: this.contractorData.pasiveIncome,
        discount: this.discount,
        reward: this.reward,
        invoiceNumber: this.contractorData.invoiceNumber,
        createdAt: null,
        dueDate: null,
        seasonFrom: this.selectedMonth.value, 
        seasonTo: this.selectedMonth.endOfMonth, 
        contractorID: `/api/contractors/${this.contractorData.id}`,
        paymentMethod: 'Prevodom',
        variableSymbol: '',
        constantSymbol: '0308',
        specificSymbol: '9999'
      },
      date: null,
      create: null,
      due: null
    }
  },
  methods: {
    disableEdit() {
      this.editable = true;

    },
    setEditable: function () {
      this.editable = false;
    },
    saveData() {
      if (!this.editable) {
        if (this.value) {
          this.loading = true;

          let newItem = {...this.item};
          let selectedDate = new Date(+this.selectedMonth.value * 1000);

          newItem.time = newItem.time ? newItem.time : Date.parse(selectedDate);

          newItem[this.keyName] =+ this.value;

          this.date = new Date(this.selectedMonth.value);
          this.create = new Date(this.date.setMonth(this.date.getMonth() + 1));
          this.due = new Date(this.create);
          this.due.setDate(this.due.getDate() + 15);
          
          this.invoice.createdAt = this.create;
          this.invoice.dueDate = this.due;

          this.invoice.variableSymbol = this.selectedMonth.value.substr(0, 7);
          this.invoice.variableSymbol = this.invoice.variableSymbol.replace('-', '');

          if (this.dataProperty !== 'discount') {
            this.invoice.discount = '0';
          }

          if (this.dataProperty !== 'reward') {
            this.invoice.reward = '0';
          }

          this.invoice[this.dataProperty] = this.value;
          this.contractorData.invoice[this.dataProperty] = this.value;

          let action = null;
          const parameter = this.contractorData.invoice;

          if (this.contractorData.invoice.id === undefined) {
            this.invoice.id = undefined;
            this.$store.dispatch('addInvoice', this.invoice).then(() => {
              this.$store.dispatch('getContractors', {seasonFrom: this.selectedMonth.value, seasonTo: this.selectedMonth.endOfMonth}).then(() => {
                  this.loading = false;
                  this.disableEdit();
                  this.value = null;
                });
            });
          } else {
            if (this.value === "0") {
              if (this.deleteEmptyInvoice() === true) {
                action = 'deleteInvoice';
              } else {
                action = 'updateInvoice';
              }
            } else {
              action = 'updateInvoice';
            }
            this.$store.dispatch(action, parameter).then(() => {
              this.$store.dispatch('getContractors', {seasonFrom: this.selectedMonth.value, seasonTo: this.selectedMonth.endOfMonth}).then(() => {
                      this.loading = false;
                      this.disableEdit();
                      this.value = null;
              });
            });
          }
        }
        this.disableEdit();
      }
    },
    deleteEmptyInvoice() {
      let willBeRemovedInvoice = true;

      willBeRemovedInvoice &= (this.contractorData.invoice.hours === '0.00' || this.contractorData.invoice.hours === null || this.contractorData.invoice.hours === '0');
      willBeRemovedInvoice &= (this.contractorData.invoice.rate === '0.00' || this.contractorData.invoice.rate === null || this.contractorData.invoice.rate === '0');
      willBeRemovedInvoice &= (this.contractorData.invoice.active === '0.00' || this.contractorData.invoice.active === null || this.contractorData.invoice.active === '0');
      willBeRemovedInvoice &= (this.contractorData.invoice.pasive === '0.00' || this.contractorData.invoice.pasive === null || this.contractorData.invoice.pasive === '0');
      willBeRemovedInvoice &= (this.contractorData.invoice.discount === '0.00' || this.contractorData.invoice.discount === null || this.contractorData.invoice.discount === '0');
      willBeRemovedInvoice &= (this.contractorData.invoice.reward === '0.00' || this.contractorData.invoice.reward === null || this.contractorData.invoice.reward === '0');

      return !!willBeRemovedInvoice;
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../assets/colors.scss";

@media only screen and (max-width: 600px) {
  input[type=number] {
    width: 30vw;
    margin: 0.3em 0.5em;
    height: 3em;
  }
}

@media (min-width: 601px) {
  input[type=number] {
    display: inline-block;
    width: 6em;
    margin: 0 0.6em;
    padding: 0 0.5em;
    height: 100%;
  }
}

.loaderDots {
  margin: auto;
  display: block;
  position: absolute;
  top: 45%;
  left: 40%;
  transform: translate(-50%, -50%);
}

input[type=number] {
  outline: none !important;
  border: 3px solid transparent;
  background: $gray;
  border-radius: 0.5em;
  box-sizing: border-box;
  font-weight: bold;
  transition: all 0.5s ease-in-out;
}


::placeholder {
  color: $company-primary;
}
</style>
